module.exports = __webpack_public_path__ + "img/79.0aa20b9c.jpg";